import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Container,
  Button,
} from '../../components';
import { OPEN_VACANCY_URL, VACANCY_OVERVIEW_URL } from '../../config/constants';

import './style.scss';

const NotFound = () => {

  const { t } = useTranslation();

  // The third period is added via CSS.
  const title = t('not_found');

  const body = t('not_found_explanation');

  return (
    <Container small className="u-margin--top-bottom--8">
      <h1>{title}</h1>

      <p>{body}</p>

      <Button type="primary" href={OPEN_VACANCY_URL}>{t('not_found_button_open_application')}</Button>
      <Button type="secondary" href={VACANCY_OVERVIEW_URL}>{t('not_found_button_vacancy_overview')}</Button>

    </Container>
  );
};

export default NotFound;
